import { protectedResources } from "../context/AuthContext/authConfig";
import { DeleteAllFeedbacksBody, Endpoint, FetchResponse } from "./types";
import { apiRequest } from "./helpers";
import { RequestType } from "./types";

export const deleteAllFeedbacks = async (reqBody: DeleteAllFeedbacksBody) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.USER_FEEDBACK;
  return apiRequest(RequestType.DELETE, url, reqBody) as Promise<FetchResponse<any>>;
};

export const deleteClientUser = async (userId: number) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.CLIENT_USERS + "/" + userId;
  return apiRequest(RequestType.DELETE, url) as Promise<FetchResponse<number>>;
};

export const deleteMainUser = async (userId: number) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.MAIN_USERS + "/" + userId;
  return apiRequest(RequestType.DELETE, url) as Promise<FetchResponse<number>>;
};

export const deleteOptionValue = async (optionValueId: number) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.CONFIG_OPTION_VALUE + "/" + optionValueId;
  return apiRequest(RequestType.DELETE, url) as Promise<FetchResponse<number>>;
};

export const deleteScraperConfig = async (configId: number) => {
  const url = protectedResources.scraperAPI.endpoint + Endpoint.CONFIG + "/" + configId;
  return apiRequest(RequestType.DELETE, url) as Promise<FetchResponse<any>>;
};
